export enum SequenceMessageTypeEnum {
  Email = 'EMAIL',
  Sms = 'SMS',
  LinkedinManual = 'LINKEDIN_MANUAL',
  Phone = 'PHONE',
}
